import * as React from "react";
import { cn } from "~/lib/utils";
import { NavigationUserEvents } from "~/modules/analytics/events/navigation";
import { track } from "~/modules/analytics/track";

// // // //

export type AnchorVariant = "default" | "unstyled";

const variantClasses: Record<AnchorVariant, string> = {
    default: "text-link hover:text-link-hover transition-colors",
    unstyled: "",
};

interface Props {
    href: string;
    ariaLabel?: string;
    analyticsLabel: string | null;
    analyticsEventProperties?: Record<string, any>;
    openInNewTab?: boolean;
    draggable?: boolean;
    variant?: AnchorVariant;
    className?: string;
    children: React.ReactNode;
    setTriggerRef?: React.Dispatch<React.SetStateAction<HTMLElement | null>>; // NOTE - used when triggering a Tooltip from this component
}

/**
 * Anchor
 * Implements an HTML anchor tag
 * NOTE - this should *ONLY* be used for navigating to external sites
 */
export function Anchor(props: Props) {
    const {
        href,
        ariaLabel,
        analyticsLabel,
        analyticsEventProperties = {},
        openInNewTab = false,
        draggable,
        variant = "unstyled",
        className,
        children,
        setTriggerRef,
    } = props;

    const resolvedClassName = cn(variantClasses[variant], className);

    // Apply target + rel props when props.openInNewTab is true
    if (openInNewTab) {
        return (
            <a
                href={href}
                className={resolvedClassName}
                aria-label={ariaLabel}
                target="_blank"
                rel="noopener"
                referrerPolicy="origin-when-cross-origin"
                draggable={draggable}
                ref={setTriggerRef}
                onClick={(e) => {
                    e.stopPropagation();

                    if (analyticsLabel == null) return;

                    track(NavigationUserEvents.anchorClick, {
                        href,
                        openInNewTab,
                        label: analyticsLabel,
                        ...analyticsEventProperties,
                    });
                }}
            >
                {children}
            </a>
        );
    }

    return (
        <a
            href={href}
            className={resolvedClassName}
            aria-label={ariaLabel}
            draggable={draggable}
            rel="noopener"
            referrerPolicy="origin-when-cross-origin"
            ref={setTriggerRef}
            onClick={() => {
                if (analyticsLabel == null) return;

                track(NavigationUserEvents.anchorClick, {
                    href,
                    openInNewTab,
                    label: analyticsLabel,
                    ...analyticsEventProperties,
                });
            }}
        >
            {children}
        </a>
    );
}
